
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import DownloadWin28 from "@/components/DownloadWin28.vue";
  import DownloadLin28 from "@/components/DownloadLin28.vue";
  import DownloadMac28 from "@/components/DownloadMac28.vue";
  import DownloadZip28 from "@/components/DownloadZip28.vue";
  import TabSwitcher from "@/components/TabSwitcher";
  import License from "@/components/License.vue";
  import {gaSendEvent} from "@/components/Analytics";
  @Component({
    components: {License, DownloadZip28, DownloadMac28, DownloadLin28, DownloadWin28}
  })
  export default class PlatformChoice extends Vue {
    @Prop()
    version: string;
    @Prop() initialPlatform: string;

    private tabSwitcher = new TabSwitcher();

    public mounted() {
      this.tabSwitcher.init(this.initialPlatform);
      gaSendEvent('download_shown');
    }
  }
